// Display-only mappings for fixed server values; unknown values fall back to the raw value.
const DIMS = ["accuracy", "fluency", "completeness", "grammar", "persuasiveness"];
const SIDES = ["for", "against"];
const QTYPES = ["mcq", "fill"];

const mapped = (list, prefix) => (t, v) => {
  const k = String(v ?? "").trim().toLowerCase();
  return list.includes(k) ? t(`${prefix}.${k}`) : v;
};

export const dimLabel = mapped(DIMS, "pm.scores");
export const sideLabel = mapped(SIDES, "pm.debate.sides");
export const qTypeLabel = mapped(QTYPES, "pm.quiz.types");

// Splits a translated sentence on a {token} so a React node can be placed inside it.
export const withNode = (text, token, node) => {
  const [a, b = ""] = text.split(`{${token}}`);
  return <>{a}{node}{b}</>;
};
